import { useRouter, useSearchParams } from 'next/navigation';

import { PlayerFiltersInterface } from '@/types/ranking.types';

interface LiveToggleProps {
  filters: PlayerFiltersInterface;
}

const LiveToggle = ({ filters }: LiveToggleProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleMobile = (type: string) => {
    const newSearchParams = new URLSearchParams(searchParams || '');
    newSearchParams.set('live', type);
    router.replace(`?${newSearchParams.toString()}`);
  };

  return (
    <div className='animate-fade-in-down flex items-center rounded-lg border border-gray-300 bg-white p-2 '>
      <div
        className={`relative flex h-[24px] w-[44px] cursor-pointer items-center rounded-full p-1 transition-colors duration-300 ${
          filters.live === 'true' ? 'bg-brand-700' : 'bg-gray-100'
        }`}
        onClick={() => handleMobile(filters.live === 'true' ? '' : 'true')}
        data-testid='rankings-toggle-live'
      >
        <div
          className={`size-5 rounded-full bg-white shadow-md transition-transform duration-300 ${
            filters.live === 'true' ? 'translate-x-[18px]' : 'translate-x-0'
          }`}
        />
      </div>
      <span className='ml-2 pl-2'>Live</span>
    </div>
  );
};

export default LiveToggle;
